<template>
    <div
        class="relative"
        :style="{ marginTop: margemParaCrescimento / 2 + 'px', marginLeft: margemParaCrescimento / 2 + 'px' }"
    >
        <img
            data-editor="invite"
            class="rounded-full shadow cursor-pointer transform duration-300"
            :class="{ 'hover:scale-110': !runningInEditor }"
            :src="imagem"
            @click="aceitarConvite()"
            :style="'width:' + tamanho + '; height: ' + tamanho"
        />

        <div v-if="countUnreadEvents > 0" class="absolute top-0 right-0">
            <div class="leading-none bg-red-500 text-red-50 font-bold text-sm rounded-full py-px px-1">
                {{ countUnreadEvents }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    computed: {
        imagem() {
            return this.$store.state.aparência.inviteImage
        },
        tamanho() {
            return this.$store.getters.tamanhoDoConvite + 'px'
        },
        margemParaCrescimento() {
            if (this.runningInEditor) return 0
            return this.$store.getters.tamanhoDoConvite * 0.1 + 2
        },

        runningInEditor() {
            return this.$store.state.ambiente == 'editor'
        },

        countUnreadEvents() {
            return this.$store.getters.countAllUnreadEvents
        },

        visible() {
            return this.$store.state.inviteVisible
        },
    },
    watch: {
        visible() {
            this.resizeIframe()
        },
    },
    mounted() {
        this.resizeIframe()
    },
    methods: {
        resizeIframe() {
            let tamanhoMaisMargemParaCrescimento = this.$store.getters.tamanhoDoConvite + this.margemParaCrescimento
            if (this.visible) {
                Teclia.__postMessage('resize', {
                    width: tamanhoMaisMargemParaCrescimento + 'px',
                    height: tamanhoMaisMargemParaCrescimento + 'px',
                })
            } else {
                Teclia.__postMessage('resize', {
                    width: '0px',
                    height: '0px',
                })
            }
        },

        aceitarConvite() {
            this.$store.dispatch('clicarNoConvite')
        },
    },
}
</script>